import { DtoPedido } from './../dominio/DtoPedido';
import { CoVendedorServicio } from './../../covendedor/servicio/covendedor.service';
import { DtoWhItemList } from './../../../logistica/whItemmast/dominio/DtoWhItemList';
import { CoDocumentodetalle } from './../../codocumento/dominio/CoDocumentodetalle';
import { CoPedidosServicio } from './../servicio/copedidos.service';
import { MaUnidadNegocioService } from './../../../core/maunidadnegocio/servicio/maunidadnegocio.servicio';
import { AcSucursalService } from './../../../core/acsucursal/servicio/acsucursal.servicio';
import { MaFormadePagoService } from './../../../core/maformadepago/servicio/maformadepago.servicio';
import { WhAlmacenmastService } from './../../../logistica/whalmacenmast/servicio/whalmacenmast.servicio';
import { SelectItem, MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, ɵConsole, ViewChild, ElementRef, forwardRef, ContentChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { CoDocumento, CoDocumentoPk } from '../../codocumento/dominio/CoDocumento';
import { MaMiscelaneosdetalleServicio } from 'src/app/erp/core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { CoDocumentoServicio } from '../../codocumento/service/codocumento.service';
import { MaFormadepago } from 'src/app/erp/core/maformadepago/dominio/maformadepago';
import { ParametrosmastServicio } from 'src/app/erp/core/parametrosmast/service/parametrosmast.service';
import { ParametrosmastPk } from 'src/app/erp/core/parametrosmast/dominio/Parametrosmast';
import { PersonamastSelectorComponent } from '../../../core/personamast/vista/selector/personamastselector.component';
import { DatePipe } from '../../../../../../node_modules/@angular/common';
import { PersonamastServicio } from 'src/app/erp/core/personamast/service/personamast.service';
import { WhItemNuevoMastComponent } from './../../../logistica/whItemmast/vista/whItemmast-listado-nuevo.component';
import { WhItemDetalleNuevoComponent } from './../../../logistica/whItemmast/vista/whitemmast-detalle-nuevo.component';
import { FiltroCoPedido } from '../dominio/FiltroCoPedido';
import { Table } from 'primeng/table';
import { WhItemMastServicio } from '../../../../erp/logistica/whItemmast/servicio/WhItemMast.service';

@Component({
    selector: 'app-pedido-mantenimiento-nuevo',
    templateUrl: './pedido-mantenimiento-nuevo.component.html'
})
export class PedidoMantenimientoNuevoComponent extends PrincipalBaseComponent implements OnInit {
    @ViewChild(PersonamastSelectorComponent, { static: false }) personamastSelectorComponent: PersonamastSelectorComponent;
    @ViewChild(WhItemNuevoMastComponent, { static: false }) whItemNuevoMastComponent: WhItemNuevoMastComponent;
    @ViewChild(WhItemDetalleNuevoComponent, { static: false }) whItemDetalleNuevoComponent: WhItemDetalleNuevoComponent;
    @ViewChild(Table, { static: false }) dt: Table;

    cargando: Boolean = true;
    bean: CoDocumento = new CoDocumento();
    origen: string;
    editarcliente: Boolean = false;
    verBotonCalcular: Boolean = true;
    urlImprimir: String = '';
    verModalDescuento: Boolean = false;
    direccionid: number;
    habilitarDescuento: Boolean = false;
    documento: CoDocumento = new CoDocumento();
    filaEditada: boolean = false;
    titulo: string = '';

    constructor(

        private parametrosmastServicio: ParametrosmastServicio,
        private router: Router,
        private route: ActivatedRoute,
        private datePipe: DatePipe,
        private maMiscelaneosdetalleServicio: MaMiscelaneosdetalleServicio,
        private coDocumentoServicio: CoDocumentoServicio,
        private maFormadePagoService: MaFormadePagoService,
        private maUnidadNegocioService: MaUnidadNegocioService,
        private acSucursalService: AcSucursalService,
        private whAlmacenmastService: WhAlmacenmastService,
        private coPedidosServicio: CoPedidosServicio,
        private confirmationService: ConfirmationService,
        private coVendedorServicio: CoVendedorServicio,
        private personamastServicio: PersonamastServicio,
        private whItemMastServicio: WhItemMastServicio,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService,
    ) { super(noAuthorizationInterceptor, messageService); }

    listaFormaPago: SelectItem[] = [];
    listaFormaPagoBean: MaFormadepago[] = [];
    listaAlmacen: SelectItem[] = [];
    listaSucursal: SelectItem[] = [];
    listaUnidadNegocio: SelectItem[] = [];
    lstEstados: SelectItem[] = [];
    lstRutaDespacho: SelectItem[] = [];
    lstFormaFactura: SelectItem[] = [];
    lstMoneda: SelectItem[] = [];
    lstVendedor: SelectItem[] = [];
    lstDireccion: SelectItem[] = [];
    lstClientes: any[];

    currency: string = 'EX';
    ib_ControlBotonDsctoBonif: Boolean = true;
    action: string;
    verMensaje1: Boolean = false;
    verMensaje2: Boolean = false;
    mensaje1: string;
    mensaje2: string;
    fila: number = 0;
    actionPantalla: string;
    esAprobador: Boolean = false;
    esAdministrador: Boolean = false;
    puedeVerMargen= false;
    dtoPersonamast: DtoPersonamast;
    filtro: FiltroCoPedido = new FiltroCoPedido();
    detalleSeleccionado: CoDocumentodetalle = new CoDocumentodetalle();


    ngOnInit(): void {
        super.ngOnInit();

        this.bloquearPagina();

        const promises = [];

        this.lstEstados.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.maMiscelaneosdetalleServicio.listarPorCabecera('CO', '999999', 'PEDEST').then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstados.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                    }
                );
            }
        ));

        this.lstRutaDespacho.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.coDocumentoServicio.listarRutaDespacho().then(
            res => {
                res.forEach(
                    reg => {
                        if (!this.estaVacio(reg.descripcion)) {
                            this.lstRutaDespacho.push({ label: reg.descripcion, value: reg.codigo.trim() });
                        }
                    }
                );
            }
        ));

        this.listaFormaPago.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.maFormadePagoService.listarActivos().then(
            res => {
                this.listaFormaPagoBean = res;
                res.forEach(
                    reg => {
                        this.listaFormaPago.push({ label: reg.descripcion, value: reg.pk.formadepago.trim() });
                    }
                );
            }
        ));


        this.listaAlmacen.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.whAlmacenmastService.listarActivosHuemura('V').then(
            res => {
                res.forEach(
                    reg => {
                        this.listaAlmacen.push({ label: reg.descripcionLocal, value: reg.almacenCodigo.trim() });
                    }
                );
            }
        ));

        this.listaSucursal.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.acSucursalService.listarActivos().then(
            res => {
                res.forEach(
                    reg => {
                        this.listaSucursal.push({ label: reg.descripcionlocal, value: reg.pk.sucursal.trim() });
                    }
                );
            }
        ));

        this.listaUnidadNegocio.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.maUnidadNegocioService.listarActivos().then(
            res => {
                res.forEach(
                    reg => {
                        this.listaUnidadNegocio.push({ label: reg.descripcionlocal, value: reg.pk.unidadnegocio.trim() });
                    }
                );
            }
        ));

        this.lstVendedor.push({ label: ' -- Seleccione -- ', value: null });
        promises.push(this.coVendedorServicio.listarActivosDto().then(
            res => {
                res.forEach(
                    reg => {
                        this.lstVendedor.push({ label: reg.vendedorNombre, value: reg.vendedor });
                    }
                );
            }
        ));

        this.coPedidosServicio.esAprobador().then(
            resp => {
                if (resp !== undefined || resp !== null) {
                    if (resp.esAprobador === 'S') {
                        this.esAprobador = true;
                    } else {
                        this.esAprobador = false;
                    }
                }
            }
        );

        this.coPedidosServicio.esAdministrador().then(
            resp => {
                if (resp !== undefined || resp !== null) {
                    if (resp.esAdministrador === 'S') {
                        this.esAdministrador = true;
                    } else {
                        this.esAdministrador = false;
                    }
                }
            }
        );

        this.coPedidosServicio.puedeVerMargen().then(
            resp => {
                if (resp !== undefined || resp !== null) {
                    if (resp.esAdministrador === 'S') {
                        this.puedeVerMargen = true;
                    } else {
                        this.puedeVerMargen = false;
                    }
                }
            }
        );

        this.lstMoneda.push({ label: ' -- Seleccione -- ', value: null });
        this.lstMoneda.push({ label: 'Local', value: 'LO' });
        this.lstMoneda.push({ label: 'Dólares', value: 'EX' });

        this.lstFormaFactura.push({ label: ' -- Seleccione -- ', value: null });
        this.lstFormaFactura.push({ label: 'Guia-Factura', value: 'GF' });
        this.lstFormaFactura.push({ label: 'Factura-Guia', value: 'FG' });
        this.lstFormaFactura.push({ label: 'Factura', value: 'F' });

        Promise.all([promises]).then(
            x => {
                setTimeout(() => { this.ngOnInit2(); }, 1000);
            }
        );
    }

    filterClienteSingle(event) {
        const query = event.query;
        this.personamastServicio.listarClientes(query).then(
            res => {
                this.lstClientes = res;
            }
        );
    }

    filterClientes(query, countries: any[]): any[] {
        const filtered: any[] = [];
        for (let i = 0; i < countries.length; i++) {
            let country = countries[i];
            if (country.busqueda.trim().toLowerCase().indexOf(query.trim().toLowerCase()) == 0) {
                filtered.push(country);
            }
        }
        return filtered;
    }

    captureId(event: any) {
        this.bean.clientenumero = event.persona;
        this.coDocumentoServicio.actualizarCliente(this.bean).then(
            resp => {
                this.bean = resp;
                this.direccionid = this.bean.clientedireccionsecuencia;
                this.bean.clientedireccionsecuencia = null;
                if (resp != null) {
                    this.lstDireccion = [];
                    this.coDocumentoServicio.obtenerDireccion(resp.clientenumero).then(
                        res => {
                            res.forEach(
                                reg => {
                                    this.lstDireccion.push({ label: reg.descripcion, value: reg.id });
                                }
                            );

                            if (res.length > 0) {
                                this.bean.clientedireccionsecuencia = this.direccionid;
                            }
                        }
                    );
                } else {
                    this.dtoPersonamast = new DtoPersonamast();
                }
            }
        ).catch(error => {
            this.mostrarMensajeAdvertencia(error);
            this.desbloquearPagina();
        });
    }

    alCerrarCabecera(bean: any) {
        this.origen = 'PEDIDO';
        this.bean = bean as CoDocumento;
        if (this.bean.pk.numerodocumento === undefined) {
            this.titulo = 'Nuevo Pedido';
        } else {
            this.titulo = 'Editar Pedido';
        }
        this.dt.reset();
    }

    ngOnInit2() {
        const currentCurrencyPk = new ParametrosmastPk();

        currentCurrencyPk.aplicacioncodigo = '999999';
        currentCurrencyPk.companiacodigo = '999999';
        currentCurrencyPk.parametroclave = 'CURRENCY';

        (this.parametrosmastServicio.obtenerPorId(currentCurrencyPk).then(
            param => {
                if (param != null && param !== undefined) {
                    if (!this.estaVacio(param.texto)) {
                        this.currency = param.texto.trim();
                    }
                }

                this.action = this.route.snapshot.params["accion"] as string;
                this.actionPantalla = this.route.snapshot.params['pantallaAccion'] as string;

                if (this.action === 'NUEVO') {
                    this.verBotonCalcular = true;
                    this.origen = 'PEDIDO';
                    this.nuevo();
                } else if (this.action === 'EDITAR') {
                    this.verBotonCalcular = true;
                    this.titulo = 'Editar Pedido';
                    this.origen = 'pedido-listado';
                    const pk = JSON.parse(this.route.snapshot.params['bean']) as any;
                    let accion = 'Editar';
                    this.editar(pk, accion);
                } else if (this.action === 'AUTO') {
                    this.verBotonCalcular = false;
                    this.origen = 'generarpedido-listado';
                    const bean = this.route.snapshot.params['bean'] as any;
                    this.automatico(JSON.parse(bean));
                } else if (this.action === 'VERITEMS') {
                    this.origen = 'PEDIDO';
                    this.action = this.actionPantalla;
                    this.bean = JSON.parse(this.route.snapshot.params['documento']) as CoDocumento;
                    if (this.bean.pk.numerodocumento === undefined) {
                        this.titulo = 'Nuevo Pedido';
                    } else {
                        this.titulo = 'Editar Pedido';
                    }
                    if (this.bean !== undefined) {
                        this.desbloquearPagina();
                    }
                } else if (this.action === 'VER') {
                    this.verBotonCalcular = false;
                    this.titulo = 'VER PEDIDO';
                    this.origen = 'pedido-listado';
                    const pk = JSON.parse(this.route.snapshot.params['bean']) as any;
                    let accion = 'Ver';
                    this.editar(pk, accion);
                } else if (this.action === 'APROBAR') {
                    this.verBotonCalcular = false;
                    this.titulo = 'APROBAR PEDIDO';
                    this.origen = 'pedido-listado';
                    const pk = JSON.parse(this.route.snapshot.params['bean']) as any;
                    let accion = 'Editar';
                    this.editar(pk, accion);
                } else {
                    throw new Error('NO CONTROLADO AUN');
                }
            }
        ));
    }

    aprobar() {
        this.confirmationService.confirm({
            header: 'Confirmación',
            icon: 'fa fa-question-circle',
            message: 'Esta Seguro de Revisar este Pedido',
            accept: () => {
                this.bloquearPagina();
                const pk: DtoPedido = new DtoPedido();
                pk.companiaSocio = this.bean.pk.companiasocio;
                pk.numeroDocumento = this.bean.pk.numerodocumento;
                pk.tipoDocumento = this.bean.pk.tipodocumento;
                pk.estado = 'RV';
                this.coDocumentoServicio.aprobarRechazarPedido(pk).then(
                    resp => {
                        if (resp !== null) {
                            this.bean = resp;
                            this.mostrarMensajeExito('El pedido N° ' + this.bean.pk.numerodocumento + ' se ha Revisado correctamente');
                            this.desbloquearPagina();
                            this.router.navigate(['/royal/pedido-listado'], { skipLocationChange: true });
                        } else {
                            this.desbloquearPagina();
                        }
                    }
                );
            }
        });
    }

    cambiarDireccion(event) {
        if (event.value != 0) {
            this.coDocumentoServicio.obtenerDireccionPorId(this.bean.clientenumero, event.value).then(
                resp => {
                    if (resp != null) {
                        this.bean.clientedireccionsecuencia = resp.pk.secuencia;
                        this.bean.clientedireccion = resp.direccion.trim();
                    }
                }
            )
        }
    }

    rechazar() {
        this.confirmationService.confirm({
            header: 'Confirmación',
            icon: 'fa fa-question-circle',
            message: 'Esta Seguro de Rechazar este Pedido',
            accept: () => {
                this.bloquearPagina();
                const pk: DtoPedido = new DtoPedido();
                pk.companiaSocio = this.bean.pk.companiasocio;
                pk.numeroDocumento = this.bean.pk.numerodocumento;
                pk.tipoDocumento = this.bean.pk.tipodocumento;
                pk.estado = 'PR';
                this.coDocumentoServicio.aprobarRechazarPedido(pk).then(
                    resp => {
                        if (resp !== null) {
                            this.bean = resp;
                            this.mostrarMensajeExito('El pedido N° ' + this.bean.pk.numerodocumento + ' se ha Rechazado correctamente');
                            this.desbloquearPagina();
                            this.router.navigate(['/royal/pedido-listado'], { skipLocationChange: true });
                        } else {
                            this.desbloquearPagina();
                        }
                    }
                );
            }
        });
    }

    editarItem(coDocumentodetalle: CoDocumentodetalle) {
        const obj: DtoWhItemList = new DtoWhItemList();
        obj.item = coDocumentodetalle.itemcodigo;
        obj.descripcionLocal = coDocumentodetalle.descripcion;
        obj.cantidad = coDocumentodetalle.cantidadpedida;
        obj.lote = coDocumentodetalle.lote;
        obj.condicion = coDocumentodetalle.condicion;
        obj.porcentajedescuento01 = coDocumentodetalle.porcentajedescuento01;
        obj.porcentajedescuento02 = coDocumentodetalle.porcentajedescuento02;
        obj.porcentajedescuento03 = coDocumentodetalle.porcentajedescuento03;
        obj.porcentajedescuento04 = coDocumentodetalle.porcentajedescuento04;
        obj.transferenciagratuitaflag = coDocumentodetalle.transferenciagratuitaflag;
        obj.porcentajedescuento01_Valid = coDocumentodetalle.porcentajedescuento01_Valid;
        obj.porcentajedescuento02_Valid = coDocumentodetalle.porcentajedescuento02_Valid;
        obj.porcentajedescuento03_Valid = coDocumentodetalle.porcentajedescuento03_Valid;
        obj.porcentajedescuento04_Valid = coDocumentodetalle.porcentajedescuento04_Valid;
        obj.descuento04flag = coDocumentodetalle.descuento04flag;
        this.bean.linea = coDocumentodetalle.pk.linea;
        this.bean.montoTotalDetalle = coDocumentodetalle.monto;
        this.bean.montoMargenDetalle = coDocumentodetalle.margen;
        this.whItemDetalleNuevoComponent.iniciarModal('EDITAR', 'PEDIDO', 'S', this.bean, obj);
    }

    automatico(bean: any) {
        this.titulo = 'Nuevo Pedido - Generación';
        this.bean = bean;
        this.bean.iv_action = 'Automatic';
        this.dtoPersonamast = new DtoPersonamast();
        this.dtoPersonamast.busqueda = bean.clientenombre;
        this.dtoPersonamast.persona = bean.clientenumero;
        this.desbloquearPagina();
    }

    nuevo() {
        this.titulo = 'Nuevo Pedido';
        let cliente: DtoPersonamast = new DtoPersonamast();
        this.bean = new CoDocumento();
        cliente.iv_action = 'Add';
        this.coPedidosServicio.wfOpen(cliente).then(
            resp => {
                if (resp !== null) {
                    this.bean = resp;
                    this.bean.iv_action = 'Add';
                    this.bean.monedadocumento = this.currency;
                }
            }
        ).catch(error => {
            this.mostrarMensajeAdvertencia(error);
            this.desbloquearPagina();
        });

        this.desbloquearPagina();
    }


    editar(pk: CoDocumentoPk, accion: string) {
        this.editarcliente = true;
        pk.companiasocio = pk.companiasocio.trim();
        pk.numerodocumento = pk.numerodocumento.trim();
        pk.tipodocumento = pk.tipodocumento.trim();
        this.coDocumentoServicio.obtenerCompletoPorId(pk, accion).then(
            x => {
                if (x !== null) {
                    x.rutadespacho = this.trim(x.rutadespacho);
                    x.almacencodigo = this.trim(x.almacencodigo);
                    x.iv_action = 'Update';
                    this.bean = x;
                    this.bean.auxFechaDocumento = this.datePipe.transform(this.bean.fechadocumento, "dd/M/yyyy HH:mm:ss");
                    this.dtoPersonamast = new DtoPersonamast();
                    this.dtoPersonamast.busqueda = x.clientenombre;
                    this.dtoPersonamast.persona = x.clientenumero;
                    this.desbloquearPagina();
                } else {
                    this.desbloquearPagina();
                }

                this.direccionid = x.clientedireccionsecuencia;
                this.bean.clientedireccionsecuencia = null;
                this.lstDireccion = [];
                this.coDocumentoServicio.obtenerDireccion(x.clientenumero).then(
                    res => {
                        res.forEach(
                            reg => {
                                if (!this.estaVacio(reg.descripcion)) {
                                    this.lstDireccion.push({ label: reg.descripcion, value: reg.id });
                                }
                            }
                        );

                        if (res.length > 0) {
                            this.bean.clientedireccionsecuencia = this.direccionid;
                        }
                    }
                );


            }
        );
    }

    verItem() {
        if (this.bean.clientenumero == null || this.bean.clientenumero == undefined) {
            this.mostrarMensajeAdvertencia('Seleccionar un cliente');
            return;
        }

        if (this.bean.almacencodigo == null) {
            this.mostrarMensajeAdvertencia('Seleccionar un cliente con almacén');
            return;
        }

        if (this.action === 'NUEVO') {
            this.bean.iv_action = 'Add';
        } else if (this.action === 'EDITAR') {
            this.bean.iv_action = 'Update';
        } else if (this.action === 'AUTO') {
            this.bean.iv_action = 'Automatic';
        }

        this.bean.auxFechaDocumento = this.datePipe.transform(new Date(), 'dd/M/yyyy HH:mm:ss');

        const almacen = this.bean.almacencodigo;
        this.whItemNuevoMastComponent.iniciarModal('PEDIDO', almacen, this.action, 'N', this.bean);
    }

    verItemPedido() {
        if (this.bean.coDocumentodetalle.length < 1) {
            this.mostrarMensajeAdvertencia('No existe registros para mostrar');
            return;
        }

        if (this.action === 'NUEVO') {
            this.bean.iv_action = 'Add';
        } else if (this.action === 'EDITAR') {
            this.bean.iv_action = 'Update';
        } else if (this.action === 'AUTO') {
            this.bean.iv_action = 'Automatic';
        }
        this.origen = 'PEDIDO';
    }

    onChange(event) {
        this.confirmationService.confirm({
            header: 'Confirmación',
            icon: 'fa fa-question-circle',
            message: 'Al cambiar la moneda desea que se actualicen los precios segun lista de precios?',
            accept: () => {
                this.bloquearPagina();
                this.coDocumentoServicio.wfSetprecios(this.bean).then(
                    resp => {
                        if (resp !== null) {
                            this.bean = resp;
                            this.desbloquearPagina();
                        } else {
                            this.desbloquearPagina();
                        }
                    }
                );
            }
        });
    }

    onChangeAlmacen(event) {
        if (this.bean.coDocumentodetalle.length > 0) {
            this.confirmationService.confirm({
                header: 'Confirmación',
                icon: 'fa fa-question-circle',
                message: 'Desea actualizar el almacén a las líneas del detalle?',
                accept: () => {
                    this.bloquearPagina();
                    this.coDocumentoServicio.actualizarAlmacen(this.bean).then(
                        resp => {
                            if (resp !== null) {
                                this.bean = resp;
                                this.desbloquearPagina();
                            } else {
                                this.desbloquearPagina();
                            }
                        }
                    );
                }
            });
        }
    }

    guardarPedido() {
        this.bloquearPagina();
        this.ib_ControlBotonDsctoBonif = false;
        this.coDocumentoServicio.guardarPedido(this.bean).then(
            pedido => {
                if (pedido != null) {
                    this.bean = pedido;
                    this.getMensajeGrabado(pedido.pk.numerodocumento);
                    this.mostrarMensajeExito('El pedido N° ' + this.bean.pk.numerodocumento + ' se ha guardado correctamente');
                    this.desbloquearPagina();
                    if (this.bean.iv_action === 'Automatic') {
                        this.coDocumentoServicio.actualizarCotizacion(this.bean).then(
                            resp => { }
                        )
                    }
                    this.router.navigate(['/royal/pedido-listado'], { skipLocationChange: true });
                } else {
                    this.desbloquearPagina();
                }
            }
        );
    }

    buscarmensaje() {
        this.bloquearPagina();
        if (this.fila > 1) {
            this.verMensaje1 = false;
            this.verMensaje2 = true;
            this.desbloquearPagina();
        } else {
            this.verMensaje1 = false;
            this.verMensaje2 = false;
            this.guardarPedido();
        }
    }
    salirMensaje1() {
        this.verMensaje1 = false;
        this.desbloquearPagina();
    }

    salirMensaje2() {
        this.verMensaje2 = false;
        this.desbloquearPagina();
    }


    registrar() {
        if (this.filaEditada == true) {
            this.mostrarMensajeExito('Existen Filas en el detalle que no han sido completadas con la validacion');
            return;
        }

        this.bloquearPagina();
        if (this.action === 'NUEVO') {
            this.bean.iv_action = 'Add';
        } else if (this.action === 'EDITAR') {
            this.bean.iv_action = 'Update';
        } else if (this.action === 'AUTO') {
            this.bean.iv_action = 'Automatic';
        }

        if (this.bean.iv_action !== 'Automatic') {
            if (this.ib_ControlBotonDsctoBonif) {
                this.confirmationService.confirm({
                    header: 'Confirmación',
                    icon: 'fa fa-question-circle',
                    message: 'Usted ejecuto el botón Calcular Dscto. \ Bonif. ?',
                    accept: () => {
                        this.coDocumentoServicio.validar(this.bean).then(
                            resp => {
                                if (resp.length > 0) {
                                    this.fila = 0;
                                    for (let i = 0, len = resp.length; i < len; i++) {
                                        if (resp[i].tipoMensaje.toString() === 'ADVERTENCIA') {
                                            this.fila++;
                                            this.mensaje1 = resp[i].mensaje;
                                        }
                                        if (resp[i].tipoMensaje.toString() === 'INFORMACION') {
                                            this.fila++;
                                            this.mensaje2 = resp[i].mensaje;
                                        }
                                    }

                                    // tslint:disable-next-line:triple-equals
                                    if (this.fila == resp.length) {
                                        this.verMensaje1 = true;
                                    } else {
                                        this.messageService.addAll(this.getMensajesUsuario(resp));
                                        this.desbloquearPagina();
                                    }
                                } else {
                                    this.desbloquearPagina();
                                    this.guardarPedido();
                                }
                            }
                        );
                    },
                    reject: () => {
                        this.desbloquearPagina();
                    }

                });
                // this.desbloquearPagina();
            } else {
                this.coDocumentoServicio.validar(this.bean).then(
                    resp => {
                        if (resp.length > 0) {
                            this.fila = 0;
                            for (let i = 0, len = resp.length; i < len; i++) {
                                if (resp[i].tipoMensaje.toString() === 'ADVERTENCIA') {
                                    this.fila++;
                                    this.mensaje1 = resp[i].mensaje;
                                }
                                if (resp[i].tipoMensaje.toString() === 'INFORMACION') {
                                    this.fila++;
                                    this.mensaje2 = resp[i].mensaje;
                                }
                            }

                            // tslint:disable-next-line:triple-equals
                            if (this.fila == resp.length) {
                                this.verMensaje1 = true;
                                this.desbloquearPagina();
                            } else {
                                this.messageService.addAll(this.getMensajesUsuario(resp));
                                this.desbloquearPagina();
                            }
                        } else {
                            this.desbloquearPagina();
                            this.guardarPedido();
                        }
                    }
                );
                // this.desbloquearPagina();
            }
        } else {
            this.ib_ControlBotonDsctoBonif = false;
            this.coDocumentoServicio.guardarPedido(this.bean).then(
                pedido => {
                    if (pedido != null) {
                        this.bean = pedido;
                        this.getMensajeGrabado(pedido.pk.numerodocumento);
                        this.mostrarMensajeExito('El pedido N° ' + this.bean.pk.numerodocumento + ' se ha guardado correctamente');
                        this.desbloquearPagina();

                        if (this.bean.iv_action === 'Automatic') {
                            this.coDocumentoServicio.actualizarCotizacion(this.bean).then(
                                resp => { }
                            );
                        }
                        this.router.navigate(['/royal/pedido-listado'], { skipLocationChange: true });
                    } else {
                        this.desbloquearPagina();
                    }
                }
            );
        }
    }

    customRowClass(rowData, rowIndex): string {
        return rowData.transferenciagratuitaflag === 'S' ? 'transferencia-gratuita-row' : '';
    }

    cancelar() {
        if (this.origen === 'PEDIDO') {
            this.router.navigate(['/royal/pedido-listado'], { skipLocationChange: true });
        } else if (this.origen === 'cliente-listado') {
            this.router.navigate(['/royal/cliente-listado', 'PEDIDO'], { skipLocationChange: true });
        } else {
            this.router.navigate(['/royal/' + this.origen], { skipLocationChange: true });
        }
    }

    calcularDescuentos() {
        this.bean.iv_action = 'Add';
        this.confirmationService.confirm({
            header: 'Confirmación',
            icon: 'fa fa-question-circle',
            message: 'Se aplicará el cálculo del descuento y bonificación para todo el detalle',
            accept: () => {
                this.bloquearPagina();
                this.coDocumentoServicio.calcularDescuentos(this.bean).then(
                    resp => {
                        if (resp != null) {
                            this.bean = resp;
                            this.mostrarMensajeExito('El  cálculo del descuento y bonificación se realizó correctamente');
                            this.ib_ControlBotonDsctoBonif = false;
                            this.desbloquearPagina();
                        } else {
                            this.desbloquearPagina();
                        }
                    }
                );
            }
        });
    }

    imprimir() {
        this.bloquearPagina();
        this.filtro.numerodoc = this.bean.pk.numerodocumento;
        this.filtro.usuarioActualCompania = this.bean.pk.companiasocio;
        this.coPedidosServicio.imprimir(
            this.filtro
        )
            .then(respuesta => {
                if (respuesta) {
                    this.desbloquearPagina();
                    const file = new Blob([respuesta], { type: 'application/pdf' });
                    this.urlImprimir = URL.createObjectURL(file);
                    window.open(this.urlImprimir.toString());
                }
            });
    }

    eliminarItem(coDocumentodetalle: CoDocumentodetalle) {
        this.bloquearPagina();
        // para tomar el nuemro del padre
        this.bean.linea = coDocumentodetalle.pk.linea;

        this.coDocumentoServicio.eliminarDetalle(this.bean).then(
            pedido => {
                if (pedido !== null) {
                    this.bean = pedido;
                    this.mostrarMensajeExito('El registro se ha eliminado correctamente');
                    this.desbloquearPagina();
                } else {
                    this.desbloquearPagina();
                }
            }
        );
    }

    verDatosGenerales() {
    }

    cancelarAccionSelector() {
        this.cargando = true;
    }


    
    onRowEditInit(detalleSeleccionado: CoDocumentodetalle) {
        this.filaEditada = true;
        if (!this.estaVacio(detalleSeleccionado.descuento04flag)) {
            if ('S' === detalleSeleccionado.descuento04flag) {
                this.habilitarDescuento = false;
            } else {
                this.habilitarDescuento = true;
            }
        }
        this.clonedCars[detalleSeleccionado.itemcodigo] = { ...detalleSeleccionado };
    }

    clonedCars: {
        [s: string]: CoDocumentodetalle;
    } = {};

    onRowEditCancel(car: CoDocumentodetalle, index: number) {
        console.log('onRowEditCancel');
        this.filaEditada = false;
        this.bean.coDocumentodetalle[index] = this.clonedCars[car.itemcodigo];
        delete this.clonedCars[car.itemcodigo];
    }
   
    onRowEditSave(detalle: CoDocumentodetalle) {
        this.detalleSeleccionado = detalle;
        if (!this.validar()) {
            this.filaEditada = false;
            delete this.clonedCars[detalle.itemcodigo];
            this.bean.cantidadItem = detalle.cantidadpedida;
            this.bean.descuento01 = detalle.porcentajedescuento01;
            this.bean.descuento02 = detalle.porcentajedescuento02;
            this.bean.descuento03 = detalle.porcentajedescuento03;
            this.bean.descuento04 = detalle.porcentajedescuento04;
            this.bean.iv_action = 'U';
            this.bean.linea = detalle.pk.linea;
            this.bean.montoTotalDetalle = detalle.monto;
            this.bean.montoMargenDetalle = detalle.margen;
            this.whItemMastServicio.calcularMontos(this.bean).then(
                resp => {
                    this.bean = resp;
                    this.desbloquearPagina();
                    this.mostrarMensajeExito('El Item N°' + detalle.itemcodigo + ' se ha actualizado Correctamente');
                    this.dt.reset();
                }
            );
        }
    }

    validar(): Boolean {
        this.filaEditada = false;
        let valida: Boolean = false;

        if (this.esNumeroVacio(this.detalleSeleccionado.porcentajedescuento01)) {
            this.detalleSeleccionado.porcentajedescuento01 = 0;
        }
        if (this.esNumeroVacio(this.detalleSeleccionado.porcentajedescuento02)) {
            this.detalleSeleccionado.porcentajedescuento02 = 0;
        }
        if (this.esNumeroVacio(this.detalleSeleccionado.porcentajedescuento03)) {
            this.detalleSeleccionado.porcentajedescuento03 = 0;
        }
        if (this.esNumeroVacio(this.detalleSeleccionado.porcentajedescuento04)) {
            this.detalleSeleccionado.porcentajedescuento04 = 0;
        }



        if (this.esNumeroVacio(this.detalleSeleccionado.cantidadpedida)) {
            this.mostrarMensajeAdvertencia('Ingrese valor en la cantidad ');
            valida = true;
        }

        if (!this.habilitarDescuento) {
            if (this.detalleSeleccionado.porcentajedescuento04 > this.detalleSeleccionado.porcentajedescuento04_Valid) {
                if (this.esNumeroVacio(this.detalleSeleccionado.porcentajedescuento04_Valid)) {
                    this.detalleSeleccionado.porcentajedescuento04_Valid = 0;
                }
                this.mostrarMensajeAdvertencia('El % #4 ingresado excede al máximo permitido x Item ' + this.detalleSeleccionado.porcentajedescuento04_Valid);
                this.detalleSeleccionado.porcentajedescuento04 = this.detalleSeleccionado.porcentajedescuento04_Valid;
                valida = true;
            }
        }


        if (this.detalleSeleccionado.porcentajedescuento02_Valid === null || this.detalleSeleccionado.porcentajedescuento02_Valid === undefined) {
            this.detalleSeleccionado.porcentajedescuento02_Valid = 0;
        }
        if (this.detalleSeleccionado.porcentajedescuento02 > this.detalleSeleccionado.porcentajedescuento02_Valid) {
            this.mostrarMensajeAdvertencia('El % #2 ingresado excede al máximo permitido x Item ' + this.detalleSeleccionado.porcentajedescuento02_Valid);
            this.detalleSeleccionado.porcentajedescuento02 = this.detalleSeleccionado.porcentajedescuento02_Valid;
            valida = true;
        }

        if (this.detalleSeleccionado.porcentajedescuento03_Valid === null || this.detalleSeleccionado.porcentajedescuento03_Valid === undefined) {
            this.detalleSeleccionado.porcentajedescuento03_Valid = 0;
        }
        if (this.detalleSeleccionado.porcentajedescuento03 > this.detalleSeleccionado.porcentajedescuento03_Valid) {
            this.mostrarMensajeAdvertencia('El % #3 ingresado excede al máximo permitido x Item ' + this.detalleSeleccionado.porcentajedescuento03_Valid);
            this.detalleSeleccionado.porcentajedescuento03 = this.detalleSeleccionado.porcentajedescuento03_Valid;
            valida = true;
        }

        return valida;
    }

    cargarCliente(bean: DtoPersonamast) {
        this.bloquearPagina();
        this.bean.clientenumero = bean.persona;
        this.bean.clientenombre = bean.busqueda;
        this.cargando = true;
        this.coDocumentoServicio.actualizarCliente(this.bean).then(
            resp => {
                if (resp != null) {
                    this.desbloquearPagina();
                    this.bean = resp;
                } else {
                    this.desbloquearPagina();
                }

            }
        );
    }
    mostrarSelectorCliente() {
        this.personamastSelectorComponent.iniciarComponente();
    }
    limpiarCliente() {
        this.dtoPersonamast = new DtoPersonamast()
    }


    autorizarDscto4() {
        this.bean.claveAutorizacion = undefined;
        if (this.bean.coDocumentodetalle.length == 0) {
            this.mostrarMensajeAdvertencia('Debe de ingresar Items al detalle');
            return;
        }

        this.verModalDescuento = true;
    }

    aceptarAutorizacion() {
        if (this.bean.claveAutorizacion === undefined || this.bean.claveAutorizacion === null) {
            this.mostrarMensajeAdvertencia('Por favor ingresar la contraseña para la autorizacion');
            return;
        }

        this.coPedidosServicio.obtenerAutorizacionDescuento04(this.bean).then(
            resp => {
                if (resp !== null) {
                    if (resp.pk.numerodocumento !== undefined) {
                        this.bean = resp;
                        this.verModalDescuento = false;
                    }
                }
            }
        ).catch(error => {
            this.mostrarMensajeAdvertencia(error);
            this.desbloquearPagina();
        });
    }
}



